"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qs = exports.upload = exports.get = exports.post = void 0;
const verConfig_1 = __importDefault(require("@tt/config"));
const vant_1 = require("vant");
const tools_1 = require("@tt/utils/src/tools");
const i18n_1 = require("@tt/i18n");
// application/x-www-form-urlencoded、multipart/form-data
const commonHeaders = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json;charset=UTF-8",
  "X-Requested-With": "XMLHttpRequest",
  lang: (0, i18n_1.getLanguage)(),
};
const typeReg = new RegExp("application/x-www-form-urlencoded+");
const typeJsonReg = new RegExp("application/json+");
const useUrl = `${verConfig_1.default.url}/api`; // process.env.NODE_ENV === "development" ? `/api` : 
let reqNum = 0;
/* Network Error Message */
const ERROR_MESSAGE = {
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  // REQUEST_ERROR: '发送请求时出现错误',
  REQUEST_ERROR: "An error occurred while sending the request",
  // NO_RESPONDING: '服务器无响应',
  NO_RESPONDING: "The server is not responding.",
  // UNKNOWN_ERROR: '未知错误',
  UNKNOWN_ERROR: "unknown error",
};
const setLoading = () => {
  if (!reqNum) {
    // 加载动画 loading
    vant_1.Toast.loading({ duration: 0 });
  }
  reqNum++;
};
const clearLoading = () => {
  if (reqNum > 0) {
    reqNum--;
  }
  if (reqNum <= 0) {
    // 清除加载动画 clear loading
    setTimeout(vant_1.Toast.clear(), 2000);
  }
};
const controller = new AbortController();
const signal = controller.signal;
/**
 * 请求 request
 * @param url { string }
 * @param option { object } headers, method, data
 * @returns
 */
const request = (url, option) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
  const token = (0, tools_1.getToken)();
  let showToast = true;
  if ("showToast" in option) {
    showToast = option.showToast;
  }
  if (showToast) {
    setLoading();
  }
  const headers = Object.assign(Object.assign(Object.assign({}, commonHeaders), { token }), ((option === null || option === void 0 ? void 0 : option.headers) || {}));
  let params = Object.assign({}, ((option === null || option === void 0 ? void 0 : option.data) || {}));
  const timeout = (option === null || option === void 0 ? void 0 : option.timeout) || 60000;
  const method = (option === null || option === void 0 ? void 0 : option.method) ? option.method.toUpperCase() : "GET";
  if (typeReg.test(headers["Content-Type"]) && method !== "GET") {
    params = qs.stringify(params);
  }
  if (typeJsonReg.test(headers["Content-Type"]) && method !== "GET") {
    params = JSON.stringify(params);
  }
  if (method.toUpperCase() === "GET") {
    url += `?${qs.stringify(params)}`;
    params = null;
  }
  try {
    const res = yield Promise.race([
      fetch(`${useUrl}${url}`, {
        method,
        headers,
        body: params,
        mode: "cors",
        signal,
      }),
      timeoutPromise(timeout),
    ]);
    clearLoading();
    if (res.status === 200) {
      const { ret, msg, data } = yield res.json();
      if (ret === 1) {
        return resolve(data);
      }
      reject({ ret, msg, data })
      return;
    }
    if (ERROR_MESSAGE[res.status]) {
      if (showToast) {
        (0, vant_1.Toast)(ERROR_MESSAGE[res.status]);
      }
    }
    else {
      if (showToast) {
        (0, vant_1.Toast)(ERROR_MESSAGE.UNKNOWN_ERROR);
      }
    }
    reject(res.statusText);
  }
  catch (error) {
    clearLoading();
    throw new Error(error);
  }
}));
// 超时处理
const timeoutPromise = (timeout) => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ status: 504, statusText: "timeout" });
    controller.abort();
    return;
  }, timeout);
});
exports.default = request;
const post = (url, data, option) => request(url, { data, method: "POST", ...option });
exports.post = post;
const get = (url, data, option) => request(url, { data, method: "GET", ...option });
exports.get = get;
// 上传文件 upload
const upload = (data) => {
  const url = "";
  let params = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      params.append(key, value);
    }
  }
  return request(url, {
    data: params,
    headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
  });
};
exports.upload = upload;
// 数据格式化 data formatting
class qs {
  static stringify(data) {
    let res = "";
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        res += `${key}=${value}&`;
      }
    }
    return res.substring(0, res.length - 1);
  }
  static parse(data) {
    const res = {};
    const dataArr = data.split("&");
    for (let i = 0, len = dataArr.length; i < len; i++) {
      const item = dataArr[i];
      const key = item.split("=")[0];
      const value = item.split("=")[1];
      res[key] = value;
    }
    return res;
  }
}
exports.qs = qs;

const dealError = (error) => {
  if (typeof error === "string") {
    vant_1.Toast(error)
  } else if (!!error.msg) {
    vant_1.Toast(error.msg)
  }
}

exports.dealError = dealError
